import reduceReducers from 'reduce-reducers';

//Siblings reducers
import caseReducer from './case-reducer';

export default reduceReducers(caseReducer);
